import React, { Component } from "react";
import Header from "../../Content/Header/Header";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import { Card } from "react-bootstrap";
import { TIFFIN_TABLE } from "../../../constants/Constants";
require("./booth.scss");

class TiffinTable extends Component {
  componentDidMount() {
    if (!checkCookie("emailId")) {
      this.setState({ redirect: true });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <div className="booth-container">
        <Header />
        <div className="booth-title">Tiffin Table</div>
        <Card.Img
          className="booth-image"
          src="https://nbcf.s3-us-west-1.amazonaws.com/resonate/PRODUCT0520-H-Idli-and-Sambar,-chutney.jpg"
        />
        <Card.Title className="booth-text">ITEMS AVAILABLE</Card.Title>
        {TIFFIN_TABLE.map(items => (
          <Card.Text className="booth-item">{items}</Card.Text>
        ))}
      </div>
    );
  }
}

export default TiffinTable;
